import request from '@/utils/request'

export const getChannelList = ({ page, size, channelName }) => {
  return request({
    url: `/news/channel/${page}/${size}`,
    params: {
      channelName
    }
  })
}

export const postChannelEdit = (data) => {
  return request({
    method: 'post',
    url: '/news/channel',
    data
  })
}

export const putChannelAdd = (data) => {
  return request({
    method: 'put',
    url: '/news/channel',
    data
  })
}

export const getChannelDetail = (id) => {
  return request({
    url: `/news/channel/${id}`
  })
}

export const deleteChannelDel = (id) => {
  return request({
    method: 'delete',
    url: `/news/channel/${id}`
  })
}

export const delChannelList = (data) => {
  return request({
    method: 'delete',
    url: '/news/channel/all',
    data
  })
}
